const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/*
 * ------------------------------------------------------------
 * Deetay: wheel passthrough for the product media gallery
 *
 * When the media list holds more images than fit across it, it
 * becomes a horizontal scroller, and Chrome will not pass a
 * vertical wheel gesture past a horizontal scroller to the page
 * behind it. Without help the wheel does nothing at all while
 * the cursor is over the product image.
 *
 * An earlier handler at the bottom of global.js worked around
 * that, but it moved the page by the raw wheel value while
 * html { scroll-behavior: smooth } was active, so every tick
 * restarted a fresh animation and the page crawled.
 *
 * This version only steps in for a slider that really is
 * scrolling sideways, since that is the only case the browser
 * cannot handle by itself. Everywhere else, including the
 * thumbnail strip and any gallery whose images already fit, the
 * browser's own scrolling is left completely alone so it feels
 * identical to the rest of the page. Where it does step in it
 * eases the page over about 180ms to match the browser's own
 * wheel animation, and ticks accumulate into the same animation
 * rather than restarting it.
 *
 * This file runs before global.js, so defining the flag the old
 * handler checks stops it from ever attaching. If that handler
 * is ever deleted from global.js, delete the flag below too.
 * ------------------------------------------------------------
 */
(function () {
  var SELECTOR = 'media-gallery ul.slider, .product__media-list.slider';
  var LEGACY_FLAG = '__deetayWheelPassthroughAttached';
  var MARK = '__deetayWheelPassthroughV4';
  var EASING = 0.3; // fraction of the remaining distance moved each frame

  try {
    Object.defineProperty(Element.prototype, LEGACY_FLAG, {
      value: true,
      writable: false,
      configurable: false,
    });
  } catch (e) {}

  var root = document.documentElement;
  var pending = 0;
  var frame = null;

  // Move the page now, ignoring the site wide smooth scrolling,
  // because the easing below is already doing that job.
  function moveBy(amount) {
    var previous = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollBy(0, amount);
    root.style.scrollBehavior = previous;
  }

  function step() {
    var move = pending * EASING;
    if (Math.abs(move) < 1) move = pending;
    pending -= move;
    moveBy(move);
    if (Math.abs(pending) >= 1) {
      frame = requestAnimationFrame(step);
    } else {
      pending = 0;
      frame = null;
    }
  }

  function toPixels(e) {
    if (e.deltaMode === 1) return e.deltaY * 16; // lines
    if (e.deltaMode === 2) return e.deltaY * window.innerHeight; // pages
    return e.deltaY;
  }

  function onWheel(e) {
    var el = e.currentTarget;
    if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return; // sideways gesture
    if (el.scrollHeight > el.clientHeight) return; // it can scroll itself

    // Only a slider that is genuinely scrolling sideways swallows
    // the wheel. If everything already fits, the browser passes
    // the gesture to the page correctly and must be left alone.
    if (el.scrollWidth <= el.clientWidth + 1) return;

    e.preventDefault();

    var distance = toPixels(e);

    // Animation frames are paused while a tab is hidden, so fall
    // back to moving straight away rather than stalling.
    if (!window.requestAnimationFrame || document.visibilityState !== 'visible') {
      moveBy(distance);
      return;
    }

    pending += distance;
    if (!frame) frame = requestAnimationFrame(step);
  }

  function attach(el) {
    if (!el || el[MARK]) return;
    el[MARK] = true;
    el.addEventListener('wheel', onWheel, { passive: false });
  }

  function scan(node) {
    (node || document).querySelectorAll(SELECTOR).forEach(attach);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scan();
    if (!window.MutationObserver) return;
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        m.addedNodes &&
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches(SELECTOR)) attach(node);
            scan(node);
          });
      });
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
